module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-inleft01.490670ad.svg";